import { Component, OnInit, ViewChild } from '@angular/core';
import {
  ScadenzaModRinvioComponent
} from '../../../common/components/fascicolo/scadenzario-rinvio/scadenza-mod-rinvio.component';
import { Adempimento } from '../../../common/models/adempimento';
import { SearchAdempimentiResponse } from '../../../common/models/dto/search-adempimenti-response';
import { TipoScadenza } from '../../../common/models/tipologiche/tipo-scadenza';
import { ServicePathsSettings } from '../../configuration/service-paths-settings';
import { HelpersService } from '../../services/helpers.service';
import { OperationsService } from '../../services/operations.service';
import { ViewManagerService } from '../../services/view-manager-service';

@Component({
    selector: 'main [adempimenti-inevasi-view]',
  templateUrl: 'adempimenti-inevasi-view.component.html',
  host: { '[attr.id]': '\'content\'' }
})

export class AdempimentiInevasiViewComponent implements OnInit {

  adempimentiInevasiList: Adempimento[] = [];
  adempimenti: Adempimento[] = [];
  tipiScadenze: TipoScadenza[] = [];
  searchAdempimentiResponse: SearchAdempimentiResponse;
  waitResponseSearch: boolean = false;
  numToView: number = 0;
  isViewAll: boolean = true;
  @ViewChild('modaleRinvioScadenza') modaleRinvioScadenza: ScadenzaModRinvioComponent;

  constructor(protected operationService: OperationsService,
              private helpers: HelpersService,
              private viewManager: ViewManagerService) {}

  ngOnInit() {
    this.viewManager.svuotaMenu();
    this.helpers.getTipiScadenza().subscribe(response => this.tipiScadenze = response);
    this.loadAdempimentiInevasi(ServicePathsSettings.DEFAULT_DIMENSION_RESEARCH_ADEMPIMENTI);
  }

  loadAdempimentiInevasi(size: number) {
    this.waitResponseSearch = true;
    this.operationService.getAdempimentiInevasi({fromResult: this.adempimentiInevasiList.length, size: size}).
      subscribe(response => this.adempimentiInevasiListResult(response));
  }

  adempimentiInevasiListResult(response: SearchAdempimentiResponse) {
    this.searchAdempimentiResponse = response;
    if (response.adempimenti.length > 0) {
      this.adempimentiInevasiList = this.adempimentiInevasiList.concat(response.adempimenti);
    }
    this.adempimenti = this.adempimentiInevasiList;
    this.waitResponseSearch = false;
    this.getTipiScadenza();
  }

  getTipiScadenza() {
    for (let tipoScadenza of this.tipiScadenze) {
      this.filterScadenza(tipoScadenza.id);
      if (document.getElementById('ts-' + tipoScadenza.id)) {
        document.getElementById('ts-' + tipoScadenza.id).classList.remove('active');
      }
    }
    this.filterScadenza('');
    if (document.getElementById('all')) {
      document.getElementById('all').classList.add('active');
    }
  }

  filterScadenza(idLabelScadenza: string): void {
    if (idLabelScadenza === '') {
      this.isViewAll = true;
      this.adempimenti = this.adempimentiInevasiList.filter((adempimento: Adempimento) => adempimento.tipoScadenza.label !== null);
    } else {
      this.isViewAll = false;
      this.adempimenti = this.adempimentiInevasiList.filter((adempimento: Adempimento) => adempimento.tipoScadenza.label === idLabelScadenza);
    }
  }

  adempimentoEvaso() {
    if (this.searchAdempimentiResponse && this.searchAdempimentiResponse.setNumeroAdempimentiTotali > 0) {
      this.searchAdempimentiResponse.setNumeroAdempimentiTotali = this.searchAdempimentiResponse.setNumeroAdempimentiTotali - 1;
    }
  }

  adempimentoRinviato() {
    let lunghezzaAttuale: number = this.adempimentiInevasiList.length;
    this.adempimentiInevasiList = [];
    this.adempimenti = [];
    this.loadAdempimentiInevasi(lunghezzaAttuale);
  }

  apriModaleRinvio(adempimento: Adempimento) {
    this.modaleRinvioScadenza.inizializza(ServicePathsSettings.URL_RINVIO_ADEMPIMENTO, adempimento, adempimento.idFascicolo, true);
  }
}
